/**
 * Loading, empty and error blocks.
 *
 * The design previews all four table states (`tableState` in the prototype),
 * so they are real components rather than a spinner someone adds later. The
 * skeleton keeps the table's own row height, so the page does not jump when
 * the data lands.
 */
import React from 'react';

export const Skeleton = ({rows = 5}: {rows?: number}) => {
  const widths = ['70%', '55%', '80%', '60%', '72%'];
  return (
    <div className="divide-y divide-borderc" aria-hidden="true">
      {Array.from({length: rows}).map((_, i) => (
        <div key={i} className="px-5 py-4">
          <div
            className="h-3.5 rounded bg-surface3"
            style={{width: widths[i % widths.length], animation: 'pulseDot 1.6s ease-in-out infinite'}}
          />
        </div>
      ))}
    </div>
  );
};

export const EmptyState = ({
  title,
  text,
  action,
}: {
  title: string;
  text: string;
  action?: React.ReactNode;
}) => (
  <div className="px-6 py-14 text-center">
    <p className="text-[14px] font-semibold text-text1">{title}</p>
    <p className="text-[13px] text-text2 mt-1.5 max-w-[48ch] mx-auto">{text}</p>
    {action && <div className="mt-5 flex justify-center">{action}</div>}
  </div>
);

export const ErrorState = ({message, onRetry}: {message?: string | null; onRetry?: () => void}) => (
  <div className="px-6 py-14 text-center">
    <p className="text-[14px] font-semibold text-text1">Netly Pay did not answer</p>
    <p className="text-[13px] text-text2 mt-1.5 max-w-[52ch] mx-auto">
      {message ?? 'The connection failed. Nothing has been changed.'}
    </p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="mt-5 h-10 px-4 rounded-[9px] text-[13.5px] font-semibold text-white bg-brand hover:brightness-110 transition-colors"
      >
        Try again
      </button>
    )}
  </div>
);
